import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Upload,
} from "antd";
// import { ProFormSelect, ProFormUploadButton } from '@ant-design/pro-form';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProfileMenu from '../../../components/ProfileMenu'
import { getLocalUrl } from "../../../functions";
import Layout from "../../../layouts/User";
// import { Link, useIntl, useModel } from 'umi';
import styles from "./index.module.scss";
import { useSelector, useDispatch } from "react-redux";

const Home: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [banks, setBanks] = useState<any>([]);
  const [profileImage, setProfileImage] = useState<any>("");
  const [profileName, setProfileName] = useState<any>("");

  let [formBankAccount] = Form.useForm();
  const { Option } = Select;
  const breadcrumbs = [
    {
      text: "หน้าหลัก",
      path: "/",
    },
    {
      text: "ข้อมูลของฉัน",
    },
  ];

  // if (!initialState || !initialState.settings) {
  //   return null;
  // }

  const getBanks = async () => {
    const sex = await axios.get(`/banks`);
    const banksOption = [];
    for (let i = 0; i < sex?.data?.data?.length; i++) {
      banksOption.push(
        <Option value={sex?.data?.data[i]?._id} key={sex?.data?.data[i]?._id}>
          {sex?.data?.data[i]?.name}
        </Option>
      );
    }

    setBanks(banksOption);
  };

  const confirmButton = async (values: any) => {
    await axios.patch(`/users/${currentUser._id}`, values);
    window.location.reload();
  };

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  useEffect(() => {
    setProfileImage(currentUser.photoURL);
    setProfileName(currentUser.displayName);
    getBanks();
    formBankAccount.setFieldsValue({
      ...currentUser.user,
      bank: currentUser.bank?._id,
      bankNumber: currentUser.bankNumber,
      imageProfile: [
        {
          name: "image.png",
          status: "done",
          url: `${currentUser.photoURL}`,
        },
      ],
    });
  }, [currentUser]);

  useEffect(() => {}, [profileImage]);

  const uploadButton = (
    <div>
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <>
      <div>
        <Form
          form={formBankAccount}
          onFinish={confirmButton}
          layout="vertical"
        >
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
            >
              <div className={styles.header}>บัญชีธนาคาร</div>
              <Divider
                style={{ background: "black", margin: "15px 0" }}
              ></Divider>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
            >
              <Form.Item
                name={`bank`}
                label={`ธนาคาร`}
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select placeholder="ธนาคาร">{banks}</Select>
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className={`${styles.field}`}
            >
              <Form.Item
                name={`bankNumber`}
                label={`เลขที่บัญชี`}
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input name="bankNumber" placeholder="เลขที่บัญชี" />
              </Form.Item>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className={`${styles.field}`}
            ></Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className={`${styles.field} ${styles.right}`}
            >
              <Button
                htmlType="submit"
                className={`${styles.confirmButton}`}
              >
                บันทึก
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default Home;
